import { Space } from 'antd';
import { useEffect, useState } from 'react';
import { postStudioApproval } from '../../../../api/studio';
import {
  CodeStudio,
  IAPIStudioInfo,
  IAPIStudioMemberHasPermissionItem,
  IAuditItem,
  IStudioMemberApprovalItem,
  RoleType,
  StudioMemberInviteStatus,
  // StudioRole,
} from '../../../../model/api-modules';
import { RoleGroupType } from '../../../../model/rbac';
import styles from './index.module.scss';
import { CommonOperateModal } from '../common-modal';
import { messageError, messageSuccess } from '../../../../components/message';
import getFormatMessage from '../../../../locales/get-format-message';
import { SelectRoleGroupComponent } from './member/select-role-group';
import { IOption } from '../organization-content';
import { ModalWrap } from '../../../component/modal-wrap';
import { IRootState } from '../../../../store/reducers';
import { useSelector } from 'react-redux';
import { AutoTable } from '../../../../components/auto-table';
import { IListItem } from '../../../../components/auto-table/model';
import { auditReadLog, auditWriteLog } from '../../../lib/aduit-log';

interface IProps {
  readonly studioInfo: IAPIStudioInfo;
  readonly applicationList: ReadonlyArray<IStudioMemberApprovalItem>;
  readonly memberList: ReadonlyArray<IAPIStudioMemberHasPermissionItem>;
  readonly loading: boolean;
  readonly onUpdate: (isAgree: boolean) => void;
  readonly rolesAndGroupsOptions: IOption[];
}
export const ApplicationComponent = (props: IProps) => {
  const [showApproveModal, setShowApproveModal] = useState<boolean>(false);
  const [showRejectModal, setShowRejectModal] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [selectRow, setSelectRow] = useState<IStudioMemberApprovalItem | null>(
    null
  );
  const [roleGroupList, setRoleGroupList] = useState<string[]>([]);
  const [authType, setAuthType] = useState<RoleGroupType>(RoleGroupType.Role);
  const userId = useSelector(
    (state: IRootState) => state.common.userInfo
  )?.UserID;
  const [isJustRole, setIsJustRole] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const handleRoleGroupChange = (
    selectedOptions: string[],
    authType: RoleGroupType.Role | RoleGroupType.Group
  ) => {
    console.log('selectedOptions审批,authType', selectedOptions, authType);
    setRoleGroupList(selectedOptions);
    setAuthType(authType);
  };

  useEffect(() => {
    auditReadLog(IAuditItem.ViewOrganizationApplications);
  }, []);

  useEffect(() => {
    const currentMember = props.memberList.find(
      (item) => item.UserID === userId
    );
    if (
      currentMember?.RbacMember?.[0]?.roleType !== RoleType.Admin &&
      currentMember?.RbacMember?.[0]?.roleType !== RoleType.Owner
    ) {
      // 没有任何角色/用户组也包括在内
      setIsJustRole(true);
    } else {
      setIsJustRole(false);
    }
  }, [props.memberList]);
  useEffect(() => {
    if (roleGroupList.length === 0) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [roleGroupList]);
  // 同意or拒绝邀请
  const approveOrReject = async (status: StudioMemberInviteStatus) => {
    // console.log(
    //   '审批-roleGroupList,authType，status',
    //   roleGroupList,
    //   authType,
    //   status
    // );
    // 审批拒绝，随便传个1
    const groupIDs =
      status === StudioMemberInviteStatus.Passed
        ? roleGroupList.map((group) => {
            if (group.startsWith('roleGroup-')) {
              return parseInt(group.substring(10), 10);
            }
            if (group.startsWith('userGroup-')) {
              return parseInt(group.substring(10), 10);
            }
            return 0;
          })
        : [1];
    if (selectRow) {
      try {
        const res = await postStudioApproval(
          props.studioInfo.studio.StudioID,
          [selectRow.ApplyUserID],
          status,
          authType,
          groupIDs // 用户组/角色id
        );
        auditWriteLog(
          status === StudioMemberInviteStatus.Passed
            ? IAuditItem.ApproveApplication
            : IAuditItem.RefuseApplication,
          {
            detail: {
              uid: [selectRow.ApplyUserID],
              status,
              authType,
              authID: groupIDs,
            },
          }
        );
        if (res && res.code === 0) {
          messageSuccess(getFormatMessage('operate_success'));
          setShowApproveModal(false);
          setShowRejectModal(false);
          props.onUpdate(
            status === StudioMemberInviteStatus.Passed // 只有同意申请才重新请求member接口
          );
        } else if (res && res.code === CodeStudio.MemberHasJoinOtherStudio) {
          messageError(getFormatMessage('user_already_joined_another_studio'));
        } else {
          messageError(getFormatMessage('operate_fail'));
          return false;
        }
      } catch (err: any) {
        messageError(err?.apiError?.message);
      }
    }
  };

  const approveOk = async () => {
    approveOrReject(StudioMemberInviteStatus.Passed);
    return true;
  };
  const rejectOk = async () => {
    approveOrReject(StudioMemberInviteStatus.Rejected);
    return true;
  };

  const renderApproveModal = () => {
    if (showApproveModal) {
      return (
        <ModalWrap
          oKText={getFormatMessage('confirm')}
          onClose={() => {
            setShowApproveModal(false);
          }}
          cancelText={getFormatMessage('cancel')}
          disabled={isDisabled}
          onOk={approveOk}
          title={getFormatMessage('approve_application')}
        >
          <div className="remove-text">
            {getFormatMessage('sure_approve_applicant')}
            <div className={styles.approveMemberForm}>
              {selectRow?.ApplyUserID}
              <SelectRoleGroupComponent
                className="applicant-select-role"
                rolesAndGroupsOptions={props.rolesAndGroupsOptions}
                setRoleGroupList={handleRoleGroupChange}
              />
            </div>
          </div>
        </ModalWrap>
      );
    }
    return null;
  };

  const renderRejectModal = () => {
    if (showRejectModal) {
      return (
        <CommonOperateModal
          okText={getFormatMessage('confirm')}
          onClose={() => {
            setShowRejectModal(false);
          }}
          className="delete-modal"
          onOk={rejectOk}
          title={getFormatMessage('reject')}
          context={
            <div className="remove-text">
              {getFormatMessage('sure_reject_applicant')}
              <br />
              {getFormatMessage('email_uppercase')}: {selectRow?.ApplyUserID}
            </div>
          }
        />
      );
    }
    return null;
  };

  const COLUMNS = [
    {
      name: getFormatMessage('member_name'),
      key: 'Username',
    },
    {
      name: getFormatMessage('email_uppercase'),
      key: 'ApplyUserID',
    },
    // {
    //   title: getFormatMessage('role_name'),
    //   dataIndex: 'RoleID',
    //   key: 'RoleID',
    //   width: 100,
    //   render: (text: number) => {
    //     return <span>{StudioRole[text]}</span>;
    //   },
    // },
    {
      name: getFormatMessage('reason'),
      key: 'Reason',
    },
    {
      name: getFormatMessage('operate'),
      key: 'action',
      width: 150,
      tableExtension: {
        renderRow(_key: any, _value: any, row: IListItem) {
          const record = row as IStudioMemberApprovalItem;
          if (isJustRole) {
            return null;
          }
          return (
            <Space size="middle">
              <a
                className={styles.operateBtn}
                onClick={() => {
                  setShowApproveModal(true);
                  setSelectRow(record);
                }}
              >
                {getFormatMessage('approve')}
              </a>
              <a
                className={styles.operateBtn}
                style={{ color: '#F54E4E' }}
                onClick={() => {
                  setShowRejectModal(true);
                  setSelectRow(record);
                }}
              >
                {getFormatMessage('refuse')}
              </a>
            </Space>
          );
        },
      },
    },
  ];
  const pageList = [...props.applicationList].slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  return (
    <Space direction="vertical" style={{ width: '100%' }} size={0}>
      <AutoTable
        // rowKey={(record) => record.id}
        tableExtension={{
          rowKey: 'id',
          // locale: {
          //   emptyText: (
          //     <Empty
          //       description={getFormatMessage('no_pending_invitations')}
          //       image={Empty.PRESENTED_IMAGE_SIMPLE}
          //     />
          //   ),
          // },
          pagination: {
            current: currentPage,
            total: pageList.length,
            pageSize,
            showTotal: (total) => {
              return getFormatMessage('total_items', {
                params: {
                  total,
                },
              });
            },
          },
          onChange: (changeInfo) => {
            if (!changeInfo) {
              return;
            }
            setCurrentPage(changeInfo.current);
            setPageSize(changeInfo.pageSize || 10);
          },
        }}
        list={pageList || []}
        configFields={COLUMNS}
        className={styles.applicationTable}
        loading={props.loading}
      />
      {renderApproveModal()}
      {renderRejectModal()}
    </Space>
  );
};
